import Modal from '@src/common/Modal';
import React from 'react';
import * as HELPER from "@src/config/helper";

const PaymentInfo = (props:any) => {
    let { show,handleClose,leadDetail,screenType } = props;
    return (
        <React.Fragment>
            <div className="model-outer upload-error-popup">
                <Modal show={show} handleClose={handleClose}>
                    <div className="payment-info-modal-body">
                        <h2 className={
                                screenType === "claim"
                                ? "payment-info-header-claim text-center mb-4"
                                : "payment-info-header text-center mb-4"
                            }>
                            {screenType === "pending_payment" ? "Pending Payment Info" : screenType === "claim" ? "Claim Details" : ""}
                        </h2>
                        {
                            screenType === "pending_payment" ? (
                                <div className="payment-info-section">
                                <h3 className="payment-info-subheader">
                                    <span className="payment-info-secondary">Pending Payment </span>
                                    <span className="payment-info-secondary">Net of Commissions</span>
                                </h3>
                                <small className="payment-info-description">
                                    (Gross Premium - Referral Fee)
                                </small>
                                <hr className="payment-info-divider" />
                                <div className="payment-info-row">
                                    <span className="payment-info-label">Gross Premiums</span>
                                    <span className="payment-info-value">
                                    {HELPER.addCurrencyFormatting(leadDetail.amount)}
                                    </span>
                                </div>
                                <hr className="payment-info-divider" />
                                <div className="payment-info-row">
                                    <span className="payment-info-label">Referral Fee</span>
                                    {leadDetail.referral_fee != null && (
                                    <span className="payment-info-value">
                                        {HELPER.addCurrencyFormatting(leadDetail.referral_fee)}
                                    </span>
                                    )}
                                </div>
                                <hr className="payment-info-divider" />
                                <div className="payment-info-row">
                                    <span className="payment-info-label">Due Date</span>
                                    <span className="payment-info-value">
                                    {leadDetail.due_date &&
                                        new Date(leadDetail.due_date).toISOString().split("T")[0]}
                                    </span>
                                </div>
                                <small className="payment-info-note">
                                    Policy Issuance Date + {leadDetail.expected_credit_term} days
                                </small>
                                </div>
                            ) : screenType === "claim" ? (
                                <>
                                <h3 className='claimHeading'>Claim Raised for:</h3>
                                <div style={{ marginBottom: "20px" }}></div> {/* Add some space between the header and the list */}
                                {leadDetail.raise_claim
                                    ?.filter((claim: any) => claim.is_raised === true)
                                    .map((claim: any, index: number) => (
                                    <div key={index}>
                                        <span style={{ color: "black" ,fontSize: "17px",display: "inline" }}>
                                        {index + 1}. {claim.label}
                                        </span>
                                        <span
                                        style={{
                                            fontStyle: "italic",
                                            color: "gray",
                                            fontSize: "0.9em",
                                            marginLeft: "8px",
                                            display: "inline"
                                        }}
                                        >
                                        Raised on: {new Date(claim.raise_date).toLocaleDateString()}
                                        </span>
                                    </div>
                                    ))}
                                </>
                            ) : null
                        }
                    </div>
                </Modal>
            </div>
        </React.Fragment>
    )
}

export default PaymentInfo;